import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faLock, faComment } from '@fortawesome/free-solid-svg-icons'
import FrontHeader from '../components/FrontHeader'
import FrontFooter from '../components/FrontFooter'

function Crypto() {
  return (
    <div>
      <div style={{backgroundColor: 'rgb(5, 8, 11)', position: 'relative'}}>
        <div class="position-absolute top-0 left-0 w-100 h-100 bg-black opacity-50" style={{zIndex: '10'}}></div>
        <FrontHeader/>
      </div>
      <section className="bg-white" style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
            <div className='mx-auto' style={{maxWidth: '48rem'}}>
                <h1 className="text-black fw-bold mb-4 font-large text-center" style={{lineHeight: '1.1'}}>Trade cryptocurrencies on our platform</h1>
                <p style={{fontSize: '18px'}} className='mb-5 text-center text-black'>Alphamexxtrade is excited to announce the launch of our new cryptocurrency trading platform. Now you can start trading Bitcoin, Ethereum and many more cryptocurrencies quickly, easily and safely from wherever you are — in just seconds. You get great margin trading leverage and short sell options with fast deposits and withdrawals. Our support team is available 24/7/365 to help get you trading on our CySEC-regulated platform with a trading volume of US $11 billion monthly.</p>
                <div className="d-flex justify-content-center">
                    <Link to="/register" state={{location: 'register'}} className="myBtn bg-prime px-4 py-2-5 rounded-5">Get started</Link>
                </div>
            </div>
        </div>
      </section>
      <section style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
            <div className='mx-auto' style={{maxWidth: '48rem'}}>
                <h1 className="fw-bold mb-5">The only platform you need to trade cryptocurrencies</h1>
                <p className="mb-5 pb-4">Enjoy trading and earning from a wide range of cryptocurrencies on our state-of-the-art platform. With access to real-time market data, comprehensive analysis tools, and dedicated customer support, we provide everything you need to navigate the dynamic world of digital currencies. Whether you're a seasoned trader or just starting out, our user-friendly interface and educational resources make it easy for you to engage with the crypto market. Join us and discover the potential for growth and innovation in this exciting financial frontier.</p>
                <h4 className="fw-bold mb-4">What is a crypto currency?</h4>
                <p className="mb-5">A cryptocurrency like bitcoin is a virtual currency traded peer-to-peer on a blockchain, independent of centralized authorities like banks and governments. Cryptocurrencies are entirely virtual, so they are not backed by physical commodities and have no intrinsic value.</p>
                <h4 className="fw-bold mb-4">Are There Investment Opportunities With Cryptocurrencies?</h4>
                <p className="mb-5">Absolutely. Cryptocurrencies have become established investment commodities among major financial institutions and have even been adopted by countries such as Australia and Japan. As with any investment though, there are risks linked to market movements, high volatility and economics.</p>
            </div>
        </div>
      </section>
      <section className="bg-white" style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
            <h1 className="mb-0 text-center fw-bold mb-4 text-black mx-auto" style={{maxWidth: '36rem'}}>Get started with trading today</h1>
            <p className="text-center mx-auto mb-0 text-black mx-auto" style={{maxWidth: '36rem'}}>It’s easy to get started. Register an account with us and get started with trading today.</p>
            <div className="row my-5 py-4">
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faBolt} className="text-prime mt-1" style={{fontSize: '18px'}} />
                        <p className="mb-0 ms-3 text-black"><b>Instant Results.</b> Start seeing instant results with fully automated trading strategies, personal managers and trading guides.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faLock} className="text-prime mt-1" style={{fontSize: '18px'}} />
                        <p className="mb-0 ms-3 text-black"><b>Secured.</b> Utilising top-tier security practices, our platform is able to handle cyberattacks and protect your assets.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faComment} className="text-prime mt-1" style={{fontSize: '18px'}} />
                        <p className="mb-0 ms-3 text-black"><b>Support. </b> Our representatives are available to assist you at anytime. Or reach us 24/7/365 on Live Chat or by email.</p>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center">
                <Link to="/register" state={{location: 'register'}} className="myBtn bg-prime px-4 py-2-5 rounded-5">Get started</Link>
            </div>
        </div>
      </section>
      <FrontFooter/>
    </div>
  )
}

export default Crypto